<template>
  <transition appear name="expand">
    <div v-bind:class="'section ' + sectiondata.side" v-bind:id="sectiondata.side + '-' + sectiondata.id" v-bind:style="sectionStyle" v-on:click="openSectionOptions">
      <div class="concrete">
        <div class="inner">
          <div class="top"></div>
          <div class="front"></div>
        </div>
      </div>

      <div class="panel" v-bind:class="{'see-through' : sectiondata.seeThrough, 'highlight' : sectiondata.highlight}" v-bind:style="sectionStyle">

        <div 
          class="seam seam-0" 
          v-bind:style="subpanelStyle"
          v-if="$parent.sectionHeightDisplay == 6.6"
          >
          <div class="seam-cover-vertical"></div>
        </div>

        <div class="seam seam-1" v-bind:style="subpanelStyle">
          <div class="seam-cover-vertical"></div>
        </div>
        <div class="seam seam-2 stripe" v-bind:style="subpanelStyle">
          <div class="seam-cover-vertical"></div>
        </div>
        <div class="seam seam-3" v-bind:style="subpanelStyle">
          <div class="seam-cover-vertical"></div>
        </div>
        <div class="seam seam-4" v-bind:style="subpanelStyle">
          <div class="seam-cover-vertical"></div>
        </div>
        <div class="seam seam-5" v-bind:class="{ 'concrete': $parent.baseMaterial === 'concrete' }" v-bind:style="subpanelStyle">
          <div class="seam-cover-vertical"></div>
        </div>
      
      </div>
      <div class="windows top">
        <div v-for="window in parseInt( sectiondata.windowTopCount )" v-bind:key="window" class="window"></div>
      </div>

      <div class="windows bottom">
        <div v-for="window in parseInt( sectiondata.windowBottomCount )" v-bind:key="window" class="window"></div>
      </div>

      <div class="door" v-bind:class="sectiondata.door"></div>
      <div 
      class="gate" 
      v-bind:class="sectiondata.gate" 
      v-bind:data-option="sectiondata.gateOption"
      v-bind:style="{backgroundColor: sectiondata.gateColor.color}"
      ></div>

      <div
      class="inner-wall inner-wall-upper"
      v-if="sectiondata.innerWall !== 'none'"
      ></div>
      <div
      class="inner-wall inner-wall-lower"
      v-if="sectiondata.innerWall !== 'none'"
      ></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'HallSection',
  props: {
    sectiondata: Object,
    height: Number
  },
  data: function() {
    return {
      sectionStyle: Object,
      levelStyle: Object,
      subpanelStyle: Object
    }
  },
  methods: {
    removeSection(){
      this.$parent.removeSection(this.sectiondata);
    },
    openSectionOptions(){
      this.$parent.configuringSection = this.sectiondata;
    },
    setLevelStyle(){
      this.levelStyle = {
        height: (this.$parent.oneMeter * this.$parent.gableSize ) - 2 + 'px'
      }
    },
    setSectionStyle(){
      this.sectionStyle = {
        width: this.$parent.sectionWidth + 'px',
        height: this.$parent.sectionHeight + 'px',
      }
    },
    setSubpanelStyle(){
      if( this.$parent.gableSize == 12 ) {
        this.subpanelStyle = {
          height: ( this.$parent.sectionHeight / 5) + 'px'
        }
      } else {
        this.subpanelStyle = {
          height: ( this.$parent.sectionHeight / 6) + 'px'
        }
      }
    },
    setGateType(type){
      this.sectiondata.gate = type;
    }
  },
  mounted: function(){
    this.setSectionStyle();
    this.setSubpanelStyle();
    this.setLevelStyle();
  },
  computed: {
    sectionGate: function(){
      return this.sectiondata.gate;
    },
    sectionDoor: function(){
      return this.sectiondata.door;
    },
    sectionColor: function(){
      return this.sectiondata.color;
    },
    levelCount: function(){
      return this.sectiondata.levelCount;
    },
    innerWall: function(){
      return this.sectiondata.innerWall;
    }
  },
  watch: {
    height: {
      immediate: true,
      deep: true,
      handler: function(){
        this.setSectionStyle();
        this.setLevelStyle();
        this.setSubpanelStyle();
      }
    },
    innerWall: function(status){
      let self = this;
      if( this.sectiondata.side === 'front' ){
        this.$parent.sections.rear.forEach(function(e){
          if( self.sectiondata.increment == e.increment ){
            e.innerWall = status;
          }
        });
      }
      
      if( this.sectiondata.side === 'rear' ){
        this.$parent.sections.front.forEach(function(e){
          if( self.sectiondata.increment == e.increment ){
            e.innerWall = status;
          }
        });
      }
    },
    levelCount: function(count){
      let self = this;
      if( this.sectiondata.side === 'front' ){
        this.$parent.sections.rear.forEach(function(e){
          if( self.sectiondata.increment == e.increment ){
            e.levelCount = count;
            if( count > 1 ){
              e.gate = 'none';
            }
          }
        });
      }
      
      if( this.sectiondata.side === 'rear' ){
        this.$parent.sections.front.forEach(function(e){
          if( self.sectiondata.increment == e.increment ){
            e.levelCount = count;
            if( count > 1 ){
              e.gate = 'none';
            }
          }
        });
      }

    },
    sectionColor: function(val){
      this.sectiondata.color = val;
      this.setSectionStyle();
    },
    gateColor: function(val){
      this.sectiondata.gateColor = val;
      this.setSectionStyle();
    },
    sectionDoor: function(){
      if( this.sectiondata.windowBottomCount == 1){
        this.sectiondata.windowBottomCount = 0;
        this.sectiondata.windowBottomOpenableCount = 0;
      }
      if( this.sectiondata.windowBottomCount > 2 ){
        this.sectiondata.windowBottomCount = 2;
        this.sectiondata.windowBottomOpenableCount = 2;
      }
    },
    sectionGate: function(){
      if( this.gate != 'none' ){
        this.sectiondata.windowTopCount = 0;
        this.sectiondata.windowBottomCount = 0;
        this.sectiondata.door = 'none';

        if( this.sectiondata.levelCount > 0 ){
          if( this.$parent.gableSize === 18 && this.sectiondata.levelCount === 1 ){
            // Dummy assignment
            this.sectiondata.levelCount = this.sectiondata.levelCount;
          } else {
            this.sectiondata.levelCount = this.sectiondata.levelCount - 1;
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  p {
    margin: 0;
  }

  .gable {
    .section {
      .panel {
      }
      &:first-child {
        .panel {
          border-left: 0px;
        
          .stripe {
            left: 0;
          }
        
        }
      }
    }
    &[data-gablesize="12"]{
      .section {
        &:nth-child(2) {
          .panel {
            border-right: 0px;
            
            .stripe {
              border-right: 0px;
            }
          }
        }
      }
    }
    &[data-gablesize="18"]{
      .section {
        &:nth-child(3) {
          .panel {
            border-right: 0px;

            .stripe {
              border-right: 0px;
            }
          }
        }
      }
    }

    .section {
      .gate {

        &:before {
          position: absolute;
          top: 100%;
          left: 0%;
          right: 0%;
          width: 100%;
          height: calc( var(--gate-height) / 2);
          content: '';
          transform: skewX(-45deg) translateX( calc( var(--gate-height) * -0.25) );
          background: url('../../public/tiretracks.png') center center no-repeat;
          background-size: contain;
          opacity: 0.1;
        }
      }
    }
  }

  .section {
    background: #ebebeb;
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    width: 0px;
    transition: all 0.25s ease-out;
    background: transparent !important;

    &:hover {
      .panel {
        opacity: 0.85;
      }
    }

    * {
      transition: all 0.25s ease-out;
    }

    &:after {
      z-index: 200;
      position: absolute;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      transition: all 0.1s;
      content: '';
      border: 3px solid rgba(0,0,0,0);
    }

    &:hover {
      &:after {
        cursor: pointer;

      }
    }

    &.highlight {
      .panel {
        position: relative;
        
        &:after {
          position: absolute;
          border: 1px solid #3f3f3f;
          top: 2px;
          left: 1px;
          right: 1px;
          bottom: 0px;
          background: rgba(255,255,255,0.15);
          content: '';
        }
      }
    }

    &.see-through {
      .panel {
        opacity: 0.4;
      }
    }

    &:last-child {
      .seam-cover-vertical {
        display: none;
      }
    }

    .panel {
      z-index: 50;
      position: relative;
      left: 0px;
      top: 0px;
      bottom: 0px;
      right: 0px;
      transition: all 0.25s ease-out;
      transform: translateY(-1px);

      .stripe {
        position: absolute;
        width: 100%;
        right: 0px;
      }

      .seam {
        box-sizing: border-box;
        background-image: url('../../public/panel-seams.png');
        background-size: 100% 100%;
        position: relative;

        &.stripe {
          .seam-cover-vertical {
          }  
        }

        &.concrete {
          background: #666;
          background-image: url('../../public/concrete.jpg');
          background-size: 64px 100%;

          .seam-cover-vertical {
            display: none !important;

            &:before, &:after {
              display: none !important;
            }
          }
        }
        
        .seam-cover-vertical {
          
          &:before, &:after {
            content: '';
            position: absolute;
            width: 1.2%;
            top: 0px;
            bottom: 0px;
            opacity: 0.5;
            z-index:100;
          }
          &:before {
            left: -1px;
            border-left: 2px solid rgba(0,0,0,0.15);
          }
          &:after {
            right: -1px;
            z-index: 101;
            border-right: 2px solid rgba(0,0,0,0.15);
          }
        }
      }
    }

    .inner-wall {
      z-index: 30;
      background: #777;
      right: 100%;
      transform: skewY(45deg) translateY(0%);
      height:56%;
      transform-origin: bottom right;
      position: absolute;
      top: 0px;
      width: 200%;

      &-lower {
        height:45%;
        top: 55%;
        z-index: 9;
      }
    }

    /* Places the inner wall on the correct side of the level */
    &.rear {
      position: relative;
      .inner-wall {
        z-index: 11;
        right: 0%;

        &-lower {
          z-index: 9;
        }
      }
    }

    .level {
      background: #444;
      transform: skewX(45deg);
      transform-origin: bottom left;
      position: absolute;
      left: -1px;
      right: -1px;
      bottom: var(--level-bottom-offset);
      height: 100px;
      z-index: 10;
      border-bottom: 2px solid #999;
    }

    .windows {
      display: flex;
      justify-content: space-around;
      position: absolute;
      z-index: 60;

      &.top {
        bottom: var(--window-upper-bottom-offset);
        left: 0px;
        right: 0px;
      }

      &.bottom {
        bottom: var(--window-lower-bottom-offset);
        left: 0px;
        right: 0px;
      }
      
      .window {
        width: var(--window-width);
        padding-bottom: var(--window-height);
        background: #a9a9e3;
        z-index: 61;
        border: 1px solid #000;
        background-image: url('../../public/window-shine.png');
        background-size: cover;
        box-sizing: border-box;
      }
    }

    .door {
      position: absolute;
      // left: 42%;
      // right: 42%;
      // top: 60%;
      width: var(--door-width);
      height: var(--door-height);
      left: 50%;
      bottom: 0px;
      z-index: 72;
      overflow: hidden;
      transform: scale(0.8) translateX(-50%);

      &:after {
        position: absolute;
        left: 0%;
        right: 0%;
        top: 0%;
        bottom: 0;
        content: '';
        opacity: 0;
        transition: all 0.25s 0.15s;
        background-size: 100% 100%;
      }

      &.solid {
        background: silver;
        transform: scale(1) translateX(-50%);
        border: 1px solid #3f3f3f;
        border-bottom: 0px;
        
        &:before {
          position: absolute;
          top: 50%;
          content: '';
          left: 2px;
          border-top: 1px solid #000;
          width: 20%;
        }
      }
      &.glass {
        background: #a9a9e3;
        z-index: 61;
        background-image: url('../../public/door-glass.png');
        background-size: 100% 100%;
        transform: scale(1) translateX(-50%);
        border: 1px solid #3f3f3f;
        border-bottom: 0px;

        &:before {
          position: absolute;
          top: 50%;
          content: '';
          left: 2px;
          border-left: 1px solid #000;
          height: 5px;
          width: 10%;
        }
        
      }
    }

    .gate {
      position: absolute;
      left: 50%;
      bottom: 0px;
      width: var(--gate-width);
      height: var(--gate-height);
      z-index: 70;
      transform: translateX(-50%);
      opacity: 0;

      &:before {
        position: absolute;
        top: 100%;
        left: 0%;
        right: 0%;
        width: 100%;
        height: calc( var(--gate-height) / 2.2);
        content: '';
        transform: skewX(45deg) translateX( calc( var(--gate-height) / 4.4) );
        background: url('../../public/tiretracks.png') center center no-repeat;
        background-size: contain;
        opacity: 0.1;
      }

      &:after {
        border-top: 1px solid #000;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
        position: absolute;
        left: 0%;
        right: 0%;
        top: 0%;
        bottom: 0;
        content: '';
        transition: all 0.25s 0.15s;
        background-size: 100% 100%;
      }

      &.folding, &.folding-electrified {
        background: #3f3f3f;
        opacity: 1;

        &:after {
          background-color: var(--gate-color);
          background-image: url('../../public/foldable.png');
          transform: translateY(0%);
        }

        &[data-option="door"]{
          &:after {
            background-image: url('../../public/foldable-door.png');
          }
        }
        &[data-option="window"]{
          &:after {
            background-image: url('../../public/foldable-window.png');
          }
        }
        &[data-option="door-window"]{
          &:after {
            background-image: url('../../public/foldable-door-window.png');
          }
        }
      }
    }
  }

</style>
